document.addEventListener('DOMContentLoaded', function() {
    // Get all team member descriptions
    const descriptions = document.querySelectorAll('.team-block__member-description');
    const modal = document.querySelector('.team-block__modal');
    const modalContent = document.querySelector('.team-block__modal-content');
    const modalImage = document.querySelector('.team-block__modal-image');
    const modalTitle = document.querySelector('.team-block__modal-title');
    const modalPositions = document.querySelector('.team-block__modal-positions');
    const modalDescription = document.querySelector('.team-block__modal-description');
    const modalLinkedin = document.querySelector('.team-block__modal-linkedin');
    const closeModalBtn = document.querySelector('.team-block__modal-close');
    
    // Function to handle modal display and scrolling
    function showModal() {
        modal.classList.remove('hidden');
        
        // Check if modal content is taller than viewport and add scrollable class if needed
        setTimeout(() => {
            const modalHeight = modalContent.offsetHeight;
            const windowHeight = window.innerHeight;
            
            if (modalHeight > windowHeight * 0.9) {
                modalContent.classList.add('scrollable');
            } else {
                modalContent.classList.remove('scrollable');
            }
            
            // Prevent body scrolling when modal is open
            document.body.style.overflow = 'hidden';
        }, 10); // Small timeout to ensure content is rendered
    }
    
    // Function to close modal
    function closeModal() {
        modal.classList.add('hidden');
        // Re-enable body scrolling
        document.body.style.overflow = '';
    }
    
    // Populate and open the modal for a given member
    function openMemberModal(member) {
        if (member.imageUrl) {
            modalImage.innerHTML = `<img src="${member.imageUrl}" alt="${member.title}">`;
        } else {
            modalImage.innerHTML = '';
        }

        modalTitle.textContent = member.title || '';

        if (member.positions) {
            const positionsArray = member.positions.split(',');
            modalPositions.innerHTML = positionsArray.map(position =>
                `<span class="team-block__member-position">${position}</span>`
            ).join('');
        } else {
            modalPositions.innerHTML = '';
        }

        modalDescription.innerHTML = member.descriptionText || '';

        if (member.linkedinUrl) {
            modalLinkedin.innerHTML = `
                <a href="${member.linkedinUrl}" target="_blank" rel="noopener noreferrer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Group">
                            <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 24H21.3333C22.8061 24 24 22.8061 24 21.3333V2.66667C24 1.19391 22.8061 0 21.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V21.3333C0 22.8061 1.19391 24 2.66667 24Z" fill="#007EBB"/>
                            <path id="Vector_2" fill-rule="evenodd" clip-rule="evenodd" d="M20.6667 20.6667H17.1052V14.6007C17.1052 12.9376 16.4733 12.0082 15.1569 12.0082C13.7249 12.0082 12.9767 12.9754 12.9767 14.6007V20.6667H9.54449V9.11115H12.9767V10.6677C12.9767 10.6677 14.0087 8.75811 16.4609 8.75811C18.9119 8.75811 20.6667 10.2549 20.6667 13.3504V20.6667ZM5.44982 7.59805C4.28073 7.59805 3.33337 6.64326 3.33337 5.46571C3.33337 4.28816 4.28073 3.33337 5.44982 3.33337C6.61892 3.33337 7.56571 4.28816 7.56571 5.46571C7.56571 6.64326 6.61892 7.59805 5.44982 7.59805ZM3.67756 20.6667H7.25651V9.11115H3.67756V20.6667Z" fill="white"/>
                        </g>
                    </svg>
                </a>
            `;
        } else {
            modalLinkedin.innerHTML = '';
        }

        // Show the modal with scrolling check
        showModal();
    }

    // Process each description
    descriptions.forEach(description => {
        // Get all data attributes
        const member = {
            title: description.getAttribute('data-title'),
            positions: description.getAttribute('data-positions'),
            descriptionText: description.getAttribute('data-description'),
            linkedinUrl: description.getAttribute('data-linkedin'),
            imageUrl: description.getAttribute('data-image'),
        };

        // Truncate the description to 200 characters
        const maxLength = 200;
        const paragraphs = description.querySelectorAll('p');

        if (paragraphs.length === 0) {
            return;
        }

        // Get the visible text of all paragraphs, preserving line breaks
        let fullText = '';
        paragraphs.forEach(p => {
            const paragraphText = document.createElement('div');
            // Convert <br> to newlines before stripping the remaining markup
            paragraphText.innerHTML = p.innerHTML.replace(/<br\s*\/?>/gi, '\n');
            fullText += paragraphText.textContent + '\n';
        });

        // Clean up the text while preserving line breaks
        fullText = fullText.replace(/ /g, ' ').trim();

        // Short descriptions are shown in full — no "More" link, no modal
        if (fullText.length <= maxLength) {
            return;
        }

        // Clear the description
        description.innerHTML = '';

        // Create a new paragraph with truncated text
        const truncatedP = document.createElement('p');
        truncatedP.textContent = fullText.substring(0, maxLength) + '...';

        // Create the "More" link
        const moreLink = document.createElement('span');
        moreLink.className = 'team-block__member-more-btn';
        moreLink.textContent = ' More';

        // Add click event to the "More" link
        moreLink.addEventListener('click', function(e) {
            e.preventDefault();
            openMemberModal(member);
        });

        // Add the "More" link to the paragraph
        truncatedP.appendChild(moreLink);

        // Add the paragraph to the description
        description.appendChild(truncatedP);
    });
    
    // Close modal when clicking the close button
    if (closeModalBtn) {
        closeModalBtn.addEventListener('click', function() {
            closeModal();
        });
    }
    
    // Close modal when clicking outside the modal content
    if (modal) {
        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                closeModal();
            }
        });
    }
    
    // Close modal when pressing Escape key
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
            closeModal();
        }
    });
    
    // Handle window resize to adjust modal scrollability
    window.addEventListener('resize', function() {
        if(!modal) {
            return;
        }
        
        if (!modal.classList.contains('hidden')) {
            // Debounce the resize handler to prevent excessive calculations
            if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
            
            this.resizeTimeout = setTimeout(() => {
                const modalHeight = modalContent.offsetHeight;
                const windowHeight = window.innerHeight;
                
                if (modalHeight > windowHeight * 0.9) {
                    modalContent.classList.add('scrollable');
                } else {
                    modalContent.classList.remove('scrollable');
                }
            }, 200); // 200ms debounce
        }
    });
});
